
import { createContext, useContext, ReactNode } from 'react';
import { AgentListItem } from '@/types/agent';

interface ChatAgentContextType {
  agents: AgentListItem[];
  isLoadingAgents: boolean;
}

const ChatAgentContext = createContext<ChatAgentContextType | undefined>(undefined);

export const useChatAgent = () => {
  const context = useContext(ChatAgentContext);
  if (context === undefined) {
    throw new Error('useChatAgent must be used within a ChatAgentProvider');
  }
  return context;
};

interface ChatAgentProviderProps {
  children: ReactNode;
  agents: AgentListItem[];
  isLoadingAgents: boolean;
}

export const ChatAgentContextProvider = ({ children, agents, isLoadingAgents }: ChatAgentProviderProps) => {
  return (
    <ChatAgentContext.Provider value={{ agents, isLoadingAgents }}>
      {children}
    </ChatAgentContext.Provider>
  );
};
